var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.futureBillings,"items-per-page":5},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"badge bg-primary"},[_vm._v("Not Paid")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }